import { RadioGroup, SelectInput, TextInput } from '@/components/inputs'
import { booleanOptions } from '@/constants'
import { Stack } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { DependentFormData } from './dependent-form.schema'
import { DateField } from '@/components'
import { DependentTypeLabelsEnum } from '@/types'

export function DependantsForm() {
  const { control } = useFormContext<DependentFormData>()

  return (
    <Stack spacing={2} mt={1}>
      <TextInput name="name" control={control} label="Nome" />
      <TextInput
        name="tax_id"
        control={control}
        label="CPF"
        mask="000.000.000-00"
      />
      <Controller
        name="birthdate"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <DateField
            label="Data de nascimento"
            error={!!error}
            helperText={error?.message}
            {...field}
          />
        )}
      />

      <SelectInput
        name="type"
        control={control}
        label="Tipo de dependente"
        options={Object.entries(DependentTypeLabelsEnum).map(
          ([key, value]) => ({
            label: value,
            value: key,
          }),
        )}
      />
      <RadioGroup
        name="irrf_deduction"
        control={control}
        label="Dedução de IRRF"
        options={booleanOptions}
        isBooleanChoice
        row
      />
    </Stack>
  )
}
